
/* Componente per la creazione delle search bar. Implementato l'autocomplite tramite la libreria UI-Material */

import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import '../SearchBarTariffa/SearchBarTariffa.css'
import { makeStyles } from "@material-ui/core/styles";
import { connect } from 'react-redux';
import {changepositionStart,changepositionEnd,selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePositionTariffaStart } from "../../redux";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {  createMuiTheme,ThemeProvider } from '@material-ui/core/styles';
import i18n from 'i18next';
import tplImage from './TPL.svg'
import stradarioImage from './Street.svg'
import aeroporto from './aeroporto.svg'
import porto from './porto.svg'
import train from './train.svg'
import metro from './metro.svg'
import traghetto from './traghetto.svg'

import L from "leaflet";
import { useLeaflet } from "react-leaflet";


const useStyles = makeStyles(theme => ({
    root: {
      color: 'black'
      },
    inputRoot: {
        color: "#000000",
        backgroundColor: 'trasparent',
        border: '2px',
        borderColor: 'white',
        position: 'relative',
        bottom: '0px',
        left: '2px'


        
    },


  }));
  const theme = createMuiTheme();

  theme.typography.h3 = {
    fontSize: '13px',
    '@media (min-width:600px)': {
      fontSize: '1.5rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '13px',
    },
  };
function SearchBarTariffa(props) {
    const inProps = props
    
    const classes = useStyles();
    const [value, setValue] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState([]);
    const {i18n} = useTranslation();
    const { map } = useLeaflet();
    
    const setImage = (string)=>{
        
        switch (string) {
            case "Aeroporto":
                return <img src={aeroporto} style={{width:'25px',height:'25px'} } alt="fermate"></img>
                
            case "Fermata Autobus":
                return <img src={tplImage} style={{width:'25px',height:'25px'}} alt="stradario"></img>
                
            case "Porto":
                return <img src={porto} style={{width:'25px',height:'25px'}} alt="stradario"></img>
            case "Stazione Ferroviaria":
                return <img src={train} style={{width:'25px',height:'25px'}} alt="stradario"></img> 
            case "Fermata Metropolitana":
                return <img src={metro} style={{width:'25px',height:'25px'}} alt="stradario"></img> 
                case "Traghetto":
                    return <img src={traghetto} style={{width:'25px',height:'25px'}} alt="stradario"></img>
            default:
                return <img src={stradarioImage} style={{width:'25px',height:'25px'}} alt="stradario"></img>
                
        }
    } 


     /* const handleClick = () => {
        
        
        
         inProps.callback(inProps.stato);

        const coordinate = [parseFloat(inProps.stato.lat),parseFloat(inProps.stato.lng)]  */
        
        /*
        
        
        const coordinate = [inProps.position.position.lat,inProps.position.position.lng]
        */
         /* setValue(`(${inProps.stato.lat}, ${inProps.stato.lng})`);
          };  */
      
          //funzione per zoomare il punto
    const handleClick = () => {        
        try {
            //inProps.callback2(inProps.stato);
            inProps.callback2(inProps.positionTariffaStart.positionTariffaStart);
        } catch (error) {   }
    }

    React.useEffect(() =>{
        
        try {
            
            if (inProps.positionTariffaStart.positionTariffaStart && inProps.positionTariffaStart.positionTariffaStart !== undefined && inProps.positionTariffaStart.positionTariffaStart !== ""   ) {
                
                setValue(inProps.positionTariffaStart.positionTariffaStart)
                inProps.callback(inProps.positionTariffaStart.positionTariffaStart);
                
            }else {
                setValue('')
                setInputValue('')
                setOptions([])
                inProps.callback(null); 
            }
            
        } catch (error) {
            setValue('')
            setInputValue('')
            setOptions([])
            inProps.callback(null); 
            
        }

    }  ,[inProps.positionTariffaStart.positionTariffaStart] //,[inProps.stato]   /* ,[inProps.stato] */ 
    )
    
    function removeDuplicates(data){
      var a = data.reduce((acc, current) => {
            const x = acc.find(item => item.lat === current.lat && item.lng === current.lng && item.nome === current.nome);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, [])
          return a
    }

React.useEffect(() => {  
        
    let active = true;
    
    (async () => {
            
        
            if (active && inputValue !== "") {
                try {
                    
                    const response = await fetch(`${window.configFile.httpProxy.urlGeocoding}?q=${inputValue}`,{headers: window.tp_headers});
                    
                    const jsonresponse = await response.json();
                    
                    let array = []
                    
                     /* jsonresponse.map(x=>{
                         ${window.configFile.httpProxy.urlGeocoding}search?q=${inputValue}
                        http://www.sardegnamobilita.it/app/nominatim/search/?&format=json&countrycodes=110&limit=10&bounded=1&q=${inputValue}
                        x["nome"] = i18n.t("Fermata") 
                        x["lng"] = x.lon
                        delete x.lon
                        array.push(x)
                    })  */
                    // dataJsonFermate.data.map(x=>{
                    //     x["nome"] = "Fermata"
                    //     x["lng"] = x.stop_lon
                    //     x["lat"] = x.stop_lat
                    //     x.description = x.stop_desc
                    //     x["type"] = x.stop_type
                    //     array.push(x)
                    // })
                    jsonresponse.data.map(x=>{
                        
                        x["nome"] = i18n.t("Fermata") 
                        x["lng"] = x.lon
                        delete x.lon
                        if(array.length <10) array.push(x)
                        //inProps.changeNomeFermataStart(x.description)
                       
                    })
                     jsonresponse.dataNom.map(x=>{
                        let valore = {
                            nome:"Stradario",
                            description: x.display_name,
                            lat: x.lat,
                            lng:x.lon
                        }
                        if(x.type !== "river" && x.address.city !== undefined ) array.push(valore)
                        
                    }) 
                   
                    setOptions(removeDuplicates(array)) 
                   
                } catch (error) {
                    
                }
                
        
    }
    })()

    return () => {
        active = false;
       
    };
},  [value, inputValue] );

    return (
        <Autocomplete
        classes={classes}
        style={{ width: 250, color: 'black'}}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
        groupBy={(option) => option.nome}
        filterOptions={(x) => x}
        freeSolo
        options={options}
        value={value}
        
        onChange={(event, newValue) => {
            
            setOptions(newValue ? [newValue, ...options] : []);
            inProps.callback(newValue);
            setValue(newValue);
            
           
        }}
        onInputChange={(event, newInputValue) => {
            /*
            if(event === null){
                setOptions(inProps.positionTariffaStart.positionTariffaStart ? [inProps.positionTariffaStart.positionTariffaStart, ...options] : options);
                inProps.callback(inProps.positionTariffaStart.positionTariffaStart[0])
                setValue(newInputValue);
            }else{
            setInputValue(newInputValue);}*/
            
            setInputValue(newInputValue);
            if(newInputValue == ""){
                inProps.callback(null);     
                setValue('')
            }
            
        }}
        renderInput={(params) => ( 
            
            <div className="contenitoreRicerca" > 
                      
                    <div className="boxTitolo2" ><Trans>{inProps.titolo}</Trans></div>
                    
                    <div className={'searchContainer2'}> 
                    
                            <TextField  placeholder={i18n.t(inProps.placeholder)} {...params} InputLabelProps={{style: {fontSize: 1, color: "gray", position:'relative', bottom:10,left: -40}}} />
                    </div>
                    <button className="localizationButton"  onClick={handleClick} >
                            <GpsFixedIcon fontSize="small"/>
                    </button>
                    
            </div>
        )}
        renderOption={(option) => {
            
            return (
                
                <Grid className="autocomplete" container alignItems="center" wrap="nowrap" spacing={1}>
                    {setImage(option.type)}
                   <Grid item xs><p className={"textSearch"} >{(!option.comune)?option.description:option.description + ' (' + option.comune +')'}</p></Grid>
                    
                </Grid>
          
            );
        }}
        />
    );
}
const mapStateToProps = state => {
    return {
        position: state.position,
        positionStart: state.positionStart,
        positionEnd: state.positionEnd,
        nomeFermataStart: state.nomeFermataStart,
        nomeFermataEnd:state.nomeFermataEnd,
        positionTariffaStart : state.positionTariffaStart
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
        changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
        changepositionEnd: (positionEnd) => dispatch(changepositionEnd(positionEnd)),
        markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
        markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
        changeNomeFermataStart: (nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd: (nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
        changePositionTariffaStart:(positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart))

    }
  }
export default connect(mapStateToProps,mapDispatchToProps) (SearchBarTariffa);